var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.103,
    height: 16.103,
    viewBox: "0 0 16.103 16.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lineal_Color",
    "data-name": "Lineal Color",
    transform: "translate(-1 -0.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168017",
    "data-name": "Path 168017",
    d: "M8.432,8.712A1.464,1.464,0,0,0,8,9.751v1.032a1.464,1.464,0,0,0,1.464,1.464H10.5a1.464,1.464,0,0,0,1.039-.432l6.279-6.279a1.464,1.464,0,0,0,0-2.071L16.782,2.433a1.464,1.464,0,0,0-2.071,0Z",
    transform: "translate(-1.877 -0.27)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168018",
    "data-name": "Path 168018",
    d: "M19.855,5.536,18.713,6.685l-3.1-3.1,1.142-1.149a1.464,1.464,0,0,1,2.071,0l1.032,1.032a1.464,1.464,0,0,1,0,2.071Z",
    transform: "translate(-3.917 -0.27)",
    fill: "#e63946"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_168376",
    "data-name": "Group 168376",
    transform: "translate(1 0.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168019",
    "data-name": "Path 168019",
    d: "M16.369,8.319a.732.732,0,0,0-.732.732v4.391a2.2,2.2,0,0,1-2.2,2.2H4.659a2.2,2.2,0,0,1-2.2-2.2V4.659a2.2,2.2,0,0,1,2.2-2.2H9.051A.732.732,0,0,0,9.051,1H4.659A3.659,3.659,0,0,0,1,4.659v8.782A3.659,3.659,0,0,0,4.659,17.1h8.782A3.659,3.659,0,0,0,17.1,13.442V9.051A.732.732,0,0,0,16.369,8.319Z",
    transform: "translate(-1 -0.998)",
    fill: "#070e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168020",
    "data-name": "Path 168020",
    d: "M7.644,7.923A2.2,2.2,0,0,0,7,9.482v1.032a2.2,2.2,0,0,0,2.2,2.2h1.032a2.2,2.2,0,0,0,1.559-.644l6.279-6.279a2.2,2.2,0,0,0,0-3.11L17.034,1.643a2.2,2.2,0,0,0-3.11,0Zm8.351-5.248,1.039,1.039a.732.732,0,0,1,0,1.032l-.629.644L14.319,3.3l.629-.629a.732.732,0,0,1,1.047,0ZM8.464,9.482a.732.732,0,0,1,.212-.52l4.618-4.618,2.071,2.071-4.618,4.618a.732.732,0,0,1-.52.212H9.2a.732.732,0,0,1-.732-.732Z",
    transform: "translate(-2.609 -0.998)",
    fill: "#070e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168021",
    "data-name": "Path 168021",
    d: "M16.369,8.319a.732.732,0,0,0-.732.732v4.391a2.2,2.2,0,0,1-2.2,2.2H4.659a2.2,2.2,0,0,1-2.2-2.2V4.659a2.2,2.2,0,0,1,2.2-2.2H9.051A.732.732,0,0,0,9.051,1H4.659A3.659,3.659,0,0,0,1,4.659v8.782A3.659,3.659,0,0,0,4.659,17.1h8.782A3.659,3.659,0,0,0,17.1,13.442V9.051A.732.732,0,0,0,16.369,8.319Z",
    transform: "translate(-1 -0.998)",
    fill: "#070e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168022",
    "data-name": "Path 168022",
    d: "M7.644,7.923A2.2,2.2,0,0,0,7,9.482v1.032a2.2,2.2,0,0,0,2.2,2.2h1.032a2.2,2.2,0,0,0,1.559-.644l6.279-6.279a2.2,2.2,0,0,0,0-3.11L17.034,1.643a2.2,2.2,0,0,0-3.11,0Zm8.351-5.248,1.039,1.039a.732.732,0,0,1,0,1.032l-.629.644L14.319,3.3l.629-.629a.732.732,0,0,1,1.047,0ZM8.464,9.482a.732.732,0,0,1,.212-.52l4.618-4.618,2.071,2.071-4.618,4.618a.732.732,0,0,1-.52.212H9.2a.732.732,0,0,1-.732-.732Z",
    transform: "translate(-2.609 -0.998)",
    fill: "#070e44"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.044405e1225c76fd86c84b305d0e9088.svg";
export { ForwardRef as ReactComponent };